import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse } from 'antd';
import { Link, useLocation,useNavigate } from 'react-router-dom';
import '../../../assets/css/patrocinadores.css';
import { CaretRightOutlined, LeftOutlined } from '@ant-design/icons';
import Slider from "react-slick";
import { CaretLeftFilled, CaretRightFilled } from '@ant-design/icons';
import { Element } from 'react-scroll/modules';

import log_blanco from '../../../assets/images/sitio/03_Patrocinadores_sitio_IES/Ies_Toliy.png';

import banner from '../../../assets/images/2022/stands/interiores/completos/stands_ind_Toljy.jpg';

import img_wsp_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_v.png';
import img_wsp from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_email_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_v.png';
import img_email from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_wsp_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_v.png';
import img_wsp_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_email_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_v.png';
import img_email_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';

import btn_fb_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_v.png';
import btn_fb from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_tw from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_tw_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_v.png';
import btn_yt from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_yt_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_v.png';
import btn_in from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_in_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_v.png';
import btn_lk from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';
import btn_lk_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_v.png';


const Toljy = (props) => {
  const { Panel } = Collapse;
  const { idioma, onMetrica, nombre } = props;
  const [hover_imagen, setHoverImagen] = useState(0);
  const [hover_redes, setHoverRedes] = useState(0);

  const ref_carousel = React.createRef();
  const [activar_carouse, setActivaCarosel] = useState(0);
  //let navigate = useNavigate();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const cambiarCarousel = (adelante) => {
    if(adelante){
        if(activar_carouse === 4){
          setActivaCarosel(1);
        }else{
          setActivaCarosel(activar_carouse+1);
        }
        ref_carousel.current.slickNext();
    }else{
        if(activar_carouse === 0){
          setActivaCarosel(4);
        }else{
          setActivaCarosel(activar_carouse-1);
        }
        ref_carousel.current.slickPrev();
    }
    
    }

  return (
    <>
      <Row align='middle'>
        <Col span={24}>
          <br /><br /><br /><br />
        </Col>
        <Col xs={{ span: 4, offset: 1 }} md={{ span: 2, offset: 2 }}>
                  <p className="salir_patrocinador">
          <Link to="/#patrocinadores" className="salir_patrocinador"><LeftOutlined /> {idioma === 'es' ? 'Salir' : 'Get out'}</Link>
          </p>
        </Col>
        <Col xs={{ span: 8, offset: 1 }} md={{ span: 4, offset: 5 }}>
          {idioma==='es' ?
            <img src={log_blanco} style={{width:'100%'}} />
          :
          <img src={log_blanco} style={{width:'100%'}} />}
        </Col>
      </Row>
      <Row align="middle">
      <Col span={24} offset={0}>
        <a href="#video" onClick={()=>{onMetrica('video',nombre)}}>
          <img src={banner} style={{width:'100%'}} />
        </a>
        <br /><br />
        </Col>
        <Col span={20} offset={2}>
          {idioma === 'es' ?
          <p className="texto_patrocinadores">
            <span className='color_verde'><strong>SOBRE NOSOTROS</strong></span>
            <br />
          Toljy es una empresa 100 % mexicana, dedicada a la fabricación de equipos para iluminación, vial, industrial, comercial, arquitectónico, mobiliario urbano y postes.
          <br /><br />
          Toljy ofrece la experiencia de 30 años en la manufactura de equipos para iluminación, brindando seguridad, innovación, confort y calidad, a través de cada uno de nuestros productos, garantizando la satisfacción de nuestros clientes.
        </p>
        :
        <p className="texto_patrocinadores">
          <span className='color_verde'><strong>ABOUT OUS</strong></span><br />
          Toljy is a 100% Mexican company, dedicated to the manufacture of equipment for lighting, road, industrial, commercial, architectural, street furniture and poles.
          <br /><br />
          Toljy offers the experience of 30 years in the manufacture of lighting equipment, providing safety, innovation, comfort and quality, through each of our products, guaranteeing the satisfaction of our customers.
        </p>}
        </Col>
        <Col span={0} offset={2}>
          <CaretLeftFilled className="flecha_agenda" onClick={() => {cambiarCarousel(false);}}/>
          </Col>

        <Element name="#video"/>
        <Col span={16} offset={4} onClick={()=>onMetrica('video',nombre)} >
          
        <br />
        <div className="contenedor_video_patrocinador">
        <iframe className="video" src="https://www.youtube.com/embed/8tYWAFqmaf8?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <br /><br />
        </Col>
        <Col span={0}>
          <CaretRightFilled className="flecha_agenda" onClick={() => {cambiarCarousel(true);}}/>
          </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:4}} className="paddin_20">
          {idioma === 'es' ?
          <a onClick={()=>onMetrica('whatsapp',nombre)}  target="_blank" href="https://api.whatsapp.com/send?phone=525583847802&text=Hola,%20me%20contacto%20desde%20el%20stand%20de%20Toljy%20de%20la%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_hover : img_wsp} style={{width:'100%'}} alt="video" /></a>
        :
        <a onClick={()=>onMetrica('whatsapp',nombre)}  target="_blank" href="https://api.whatsapp.com/send?phone=525583847802&text=Hello,%20I%20am%20contacted%20from%20the%20IES%20Toljy%20booth." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_en_hover : img_wsp_en} style={{width:'100%'}} alt="video" /></a>}
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:0}} className="paddin_20">
        {idioma === 'es' ? 
        <a onClick={()=>onMetrica('mail',nombre)}  target="_blank" href="mailto:comercial@toljy.com" onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 2 ? img_email_hover : img_email} style={{width:'100%'}} alt="video" /></a>
      :
      <a onClick={()=>onMetrica('mail',nombre)}  target="_blank" href="mailto:comercial@toljy.com" onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 2 ? img_email_en_hover : img_email_en} style={{width:'100%'}} alt="video" /></a>}
        </Col>
       </Row>
      <Row>
        <Col span={16} offset={4}>
          <br /><br />
        </Col>
        <Col span={20} offset={2}>
        {idioma === 'es' ?
          <p className="titulo_patrocinador_texto">PREGUNTAS FRECUENTES</p>
        :
        <p className="titulo_patrocinador_texto">FREQUENT QUESTIONS</p>
        }
        </Col>
        <Col span={20} offset={2}>
          <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            className="site-collapse-custom-collapse"
          >
            {idioma === 'es' ?
            <Panel header="¿Cuáles son las ventajas que ofrece Toljy?" key="1" className="panel_patrocinador">
                  <ul className="texto_patrocinadores">
                  <li>Asesoría profesional en proyectos de iluminación.</li>
                  <li>Los mejores tiempos de entrega del mercado.</li>
                  <li>Capacidad de respuesta inmediata.</li>
                  <li>Sólida red de distribuidores en la República Mexicana.</li>
                  <li>Certificaciones NOM 031, PAESE, FIDE en nuestros productos.</li>
                  <li>Diseños específicos acorde a las necesidades de cada proyecto o custom made.</li>
                  </ul>
            </Panel>
            :
            <Panel header="What are the advantages offered by Toljy?" key="1" className="panel_patrocinador">
                  <ul className="texto_patrocinadores">
                    <li>Professional advice on lighting projects.</li>
                    <li>The best delivery times in the market.</li>
                    <li>Immediate response capacity.</li>
                    <li>Solid network of distributors in the Mexican Republic.</li>
                    <li>NOM 031, PAESE, FIDE certifications in our products.</li>
                    <li>Specific designs according to the needs of each project or custom made.</li>
                  </ul>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Dónde puedo conocer sus luminarios?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Puedes visitar nuestra página web en www.toljy.com o descargar nuestro catálogo de productos en <a target="_blank" className="texto_patrocinadores_link" href="http://toljy.com/cat16b.pdf">http://toljy.com/cat16b.pdf</a>
                  </p>
            </Panel>
            :
            <Panel header="Where can I find out about your luminaries?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  You can visit our website at www.toljy.com or download our product catalog at <a target="_blank" className="texto_patrocinadores_link" href="http://toljy.com/cat16b.pdf">http://toljy.com/cat16b.pdf</a>
                  </p>
            </Panel>}
            {idioma === 'es' ? 
            <Panel header="¿Como contribuye Toljy con la comunidad de iluminación en México?" key="3" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contribuimos a la comunidad a través de webinars, cursos a nuestros distribuidores, asesorías y un blog el cual podrás visitar en <a target="_blank" className="texto_patrocinadores_link" href="http://toljy.com/sitio/category/blog/">http://toljy.com/sitio/category/blog/</a>, trabajando de la mano de lighting designers con el objetivo de adaptarnos a las necesidades y nuevas tendencias que el mercado de la iluminación demanda.
                  </p>
            </Panel>
            :<Panel header="How does Toljy contribute to the lighting community in Mexico?" key="3" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            We contribute to the community through webinars, courses for our distributors, consultancies and a blog which you can visit at <a target="_blank" className="texto_patrocinadores_link" href="http://toljy.com/sitio/category/blog/">http://toljy.com/sitio/category/blog/</a>, working hand in hand with lighting designers with the aim of adapt to the needs and new trends that the lighting market demands.
            </p>
      </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Cómo me comunico con ustedes?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Puedes comunicarte al correo: <a target="_blank" className="texto_patrocinadores_link" href="mailto:comercial@toljy.com">comercial@toljy.com</a> o enviar un mensaje de WhatsApp al 55 8384 7802.
                  </p>
            </Panel>
            :
            <Panel header="How do I communicate with you?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  You can contact the email: <a target="_blank" className="texto_patrocinadores_link" href="mailto:comercial@toljy.com">comercial@toljy.com</a> o enviar un mensaje de WhatsApp al 55 8384 7802.
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Ofrecen alguna garantía?" key="5" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Nuestra garantía se extiende de 5 y 10 años contra cualquier vicio oculto o defecto de fabricación, y nuestra promesa de calidad en el custom made de nuestros productos.
                  </p>
            </Panel>
            :
            <Panel header="Do you offer any guarantee?" key="5" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Our guarantee extends from 5 to 10 years against any hidden vice or manufacturing defect, and our promise of quality in the custom made of our products.
                  </p>
            </Panel>}
           {idioma === 'es' ?
           <Panel header="¿En dónde se encuentran ubicados?" key="6" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Contamos con una planta de fabricación ubicada en Acolman, Estado de México, y una bodega en Tizayuca Hidalgo, además de oficinas en el área metropolitana de la CDMX.
                  </p>
            </Panel>
            :
            <Panel header="Where are they located?" key="6" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            We have a manufacturing plant located in Acolman, State of Mexico, and a warehouse in Tizayuca Hidalgo, as well as offices in the CDMX metropolitan area.
            </p>
      </Panel>}
            {idioma === 'es' ?
            <Panel header="Productos que destacar" key="7" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Conoce las siguientes familias de productos Toljy:
                  </p>
                  <ul className="texto_patrocinadores">
                  <li>Lima</li>
                  <li>California</li>
                  <li>Ibiza</li>
                  </ul>
            </Panel>
            :
            <Panel header="Products to highlight" key="7" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Meet the following Toljy product families:
                  </p>
                  <ul className="texto_patrocinadores">
                  <li>Lima</li>
                  <li>California</li>
                  <li>Ibiza</li>
                  </ul>
            </Panel>}
          </Collapse>
        </Col>
        <Col span={20} offset={2}>
        <br /><br />
        {idioma === 'es' ?
        <p className="tituLogos">Obtener más información</p>
        :
        <p className="tituLogos">Get more information</p>}
        </Col>
        <Col xs={{span:10,offset:7}} md={{span:6,offset:9}}>
        
        <Row justify='center'>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('facebook',nombre)}  href="https://www.facebook.com/toljyiluminacion" target="_blank" onMouseEnter={()=>setHoverRedes(1)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 1 ? btn_fb_hover : btn_fb} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('twitter',nombre)}  href="https://twitter.com/Toljy" target="_blank" onMouseEnter={()=>setHoverRedes(2)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 2 ? btn_tw_hover : btn_tw} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={0} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('youtube',nombre)}  href="" target="_blank" onMouseEnter={()=>setHoverRedes(3)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 3 ? btn_yt_hover : btn_yt} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores contenedor_redes_patrocinadores_rigth">
            <a onClick={()=>onMetrica('instagram',nombre)}  href="https://www.instagram.com/toljymx/" target="_blank" onMouseEnter={()=>setHoverRedes(4)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 4 ? btn_in_hover : btn_in} className="patrocinadores_redes_img" /></a>
          </Col>
        </Row>
        <br />
        </Col>
      </Row>
    </>
  )
}
export default Toljy;